import React from "react";
import Header from "../../../components/Header";
import StockRequestsTable from "../../../tables/StoreManagement/StockRequestsTable";

const StockRequestsPage = () => {
  return (
    <div className="min-h-screen bg-[#F6F7F6]">
      <Header text="Stock Requests" />
      <div className="mt-6">
        <StockRequestsTable />
      </div>
    </div>
  );
};

export default StockRequestsPage;
